module.exports = __webpack_public_path__ + "media/images/operative-34c33e50.svg";